/*
 * Copyright 2025 Intuition Robotics ltd
 */
import __asset_0 from "@res/icons/btn_toggle_off.svg";
import __asset_1 from "@res/icons/btn_toggle_on.svg";
import * as React from "react";

type Props = {
	on: boolean
	onChange: (on: boolean) => void
}

const off = __asset_0;
const on = __asset_1;

export class Toggle
	extends React.Component<Props> {

	render() {
		const isOn = this.props.on;
		return <img onClick={() => this.props.onChange(!isOn)} src={isOn ? on : off} alt="on"/>;
	}

}